<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import indowWindowInsert from './images/Memorial-Day-image-03.jpg';

	let { class: className } = $props();
</script>

<Section
	imageColumn={indowWindowInsert}
	columnPosition="left"
	backgroundColor="grey-dark"
	class={className}
>
	<h2>Why Choose Indow?</h2>
	<p>
		Our inserts are custom cut to your specific windows in virtually any size or
		shape<a
			href="#‡"
			class="no-underline"
			title="Pricing for non-rectangular windows varies by shape. Inquire for a customized quote."
			><sup class="text-indow-white">‡</sup></a
		>. They come fitted with our patented compression tubing in a variety of
		colors, so they'll blend in and slide right into place without any need for
		hardware or professional installation. We manufacture our inserts right here
		in the USA and ship them directly to your home in the US or Canada within
		weeks of your order.
	</p>
	<p>
		Connect with one of our Fit Specialists today to ensure Indow inserts are
		the right solution for your home and get a free estimate. We'll answer any
		questions and guide you through the steps to measure your windows and
		maximize the comfort of your space.
	</p>
	<ul class="list-none text-sm">
		<li id="‡">
			<p class="text-left">
				‡ Pricing for non-rectangular windows varies by shape. Inquire for a
				customized quote.
			</p>
		</li>
	</ul>
</Section>
